// Login page: select a mock user to authenticate and navigate accordingly.
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, TextField, Button, Box, Paper, Alert } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import apiClient from '../api/apiClient'; // Import the apiClient

export default function Login() {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Use navigate for redirection

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    try {
      // Call the backend API
      const response = await apiClient.post('/auth/login', { username, password });
      const { access_token, user } = response.data;
      
      // Store token and user data using AuthContext
      login(user, access_token);

      // Redirect based on role (Assuming login function in AuthContext handles redirection or sets user state)
      // Or redirect directly here:
      // navigate('/'); // Or specific dashboard based on user.role

    } catch (err) {
      console.error("Login failed:", err);
      if (err.response && err.response.data) {
        const problem = err.response.data;
        setError(problem.detail || problem.title || 'Login failed. Please check your credentials.');
      } else {
        setError('Login failed. Please check your connection or try again later.');
      }
    }
  };

  return (
    <div className="login-container">
      <Paper elevation={0} className="login-card">
        <div className="login-logo">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: '#1565c0' }}>
            VesselChain
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Secure maritime fuel documentation
          </Typography>
        </div>
        
        <Box component="form" onSubmit={handleSubmit}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
            required
            variant="outlined"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <Button 
            type="submit" 
            variant="contained" 
            fullWidth
            size="large"
            sx={{ 
              py: 1.5, 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '1rem',
              backgroundColor: '#1565c0',
              '&:hover': {
                backgroundColor: '#0d47a1'
              }
            }}
          >
            Sign In
          </Button>
        </Box>
      </Paper>
      <Box
        component="img"
        src="/banner-ports.png"
        alt="Proyecto financiado por el Fondo PORTS 4.0"
        sx={{
          mt: 4,
          maxWidth: '100%',
          width: 500,
          height: 'auto'
        }}
      />
    </div>
  );
}
